/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("PartnersSubcontractors", ["jquery", "Behaviors"], factory);
    } else {
        root.PartnersSubcontractors = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};
    function PartnersSubcontractors() {
        Behaviors.init(PartnersSubcontractors, this, arguments);

        
        var tabItem = this.$elem.find(PartnersSubcontractors.ELEMENTS.partnerTabLink);
        var tabContent = this.$elem.find(PartnersSubcontractors.ELEMENTS.partnerTabContainer);
        
        tabItem.on('click', function(e) {

            e.preventDefault();

            var target = this.getAttribute('href').replace('#','');

            var tabs = document.querySelectorAll( PartnersSubcontractors.ELEMENTS.partnerTabLink );

            var containers = document.querySelectorAll( PartnersSubcontractors.ELEMENTS.partnerTabContainer );

            tabs.forEach( el => {

                if(el.classList.contains('active')){
                    el.classList.remove('active'); 
                }
   
            });

            containers.forEach( el => {

                if(el.classList.contains('active')){
                    el.classList.remove('active'); 
                }
   
            });
           
            this.classList.add('active');

            document.getElementById(target).classList.add('active');

        });
        
    }

    Behaviors.inherit(PartnersSubcontractors, Behaviors.Behavior);

    PartnersSubcontractors.QUERY = "[data-partners-subcontractors]";

    PartnersSubcontractors.ELEMENTS = {
        partnerTabLink: ".tab-btn",
        partnerTabContainer: ".partner-container",
    };
    
    Behaviors.register_behavior(PartnersSubcontractors);

    module.PartnersSubcontractors = PartnersSubcontractors;

    return module;
}));
